import React from "react";
import { Box } from "@mui/material";
import { COLORS } from "../../Theme/colors";
import Corners from "./Corners";

interface ClearPageCornerArtLayoutProps {
  children: React.ReactNode;
}

const ClearPageCornerArtLayout: React.FC<ClearPageCornerArtLayoutProps> = ({
  children
}) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        background: `linear-gradient(to bottom, #F2F7FB, ${COLORS.WHITE})`,
        minHeight: "100vh",
        position: "relative",
        width: "100%",
        fontFamily: "Inter, sans-serif",
        "& .MuiInputBase-root": {
          fontFamily: "Inter, sans-serif",
          color: COLORS.DARK_GRAY,
          "& .MuiInputBase-input": {
            fontFamily: "Inter, sans-serif",
            color: COLORS.DARK_GRAY
          }
        },
        "& .MuiFormHelperText-root, .MuiFormLabel-root": {
          fontFamily: "Inter, sans-serif"
        }
      }}
    >
      <Corners />
      <Box sx={{ zIndex: "10" }}>{children}</Box>
    </Box>
  );
};

export default ClearPageCornerArtLayout;
